import React from "react";
import Typography from "@material-ui/core/Typography";
import { FileInput } from "../components/FileInput";
import { Card } from "../components/Card";
import { Button, Grid } from "@material-ui/core";

export default function BrandingForm({
    background,
    onBackgroundChange,
    topLogo,
    onTopLogoChange,
    bottomLogo,
    onBottomLogoChange,
    onRemoveBackground,
    onRemoveTopLogo,
    onRemoveBottomLogo,
}) {
    return (
        <div>
            <Card>
                <Typography variant="caption" display="block" gutterBottom>
                    360 background image for Mighty Launcher.
                </Typography>
                {background && <img src={background} style={{ width: 150 }} />}
                <br />
                <Grid container alignItems={"flex-end"}>
                    <Grid item>
                        <FileInput
                            id="background-button-file"
                            accept=".png"
                            onChange={onBackgroundChange}
                        >
                            New 360 Background
                        </FileInput>
                    </Grid>
                    <Grid item>
                        {background && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginLeft: 10 }}
                                onClick={onRemoveBackground}
                            >
                                Remove
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Card>
            <br />
            <Card>
                <Typography variant="caption" display="block" gutterBottom>
                    Top Logo for Mighty Launcher
                </Typography>
                {topLogo && <img src={topLogo} style={{ width: 100 }} />}
                <br />
                <Grid container alignItems={"flex-end"}>
                    <Grid item>
                        <FileInput
                            id="toplogo-button-file"
                            accept=".png"
                            onChange={onTopLogoChange}
                        >
                            New Top Logo
                        </FileInput>
                    </Grid>
                    <Grid item>
                        {topLogo && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginLeft: 10 }}
                                onClick={onRemoveTopLogo}
                            >
                                Remove
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Card>
            <br />

            <Card>
                <Typography variant="caption" display="block" gutterBottom>
                    Bottom Logo for Mighty Launcher
                </Typography>
                {bottomLogo && <img src={bottomLogo} style={{ width: 100 }} />}
                <br />
                <Grid container alignItems={"flex-end"}>
                    <Grid item>
                        <FileInput
                            id="bottomlogo-button-file"
                            accept=".png"
                            onChange={onBottomLogoChange}
                        >
                            New Bottom Logo
                        </FileInput>
                    </Grid>
                    <Grid item>
                        {bottomLogo && (
                            <Button
                                variant="contained"
                                color="primary"
                                style={{ marginLeft: 10 }}
                                onClick={onRemoveBottomLogo}
                            >
                                Remove
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Card>
        </div>
    );
}
